import { render, staticRenderFns } from "./table_service_card_alert.vue?vue&type=template&id=6231f7ee&scoped=true"
import script from "./table_service_card_alert.vue?vue&type=script&lang=js"
export * from "./table_service_card_alert.vue?vue&type=script&lang=js"
import style0 from "./table_service_card_alert.vue?vue&type=style&index=0&id=6231f7ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6231f7ee",
  null
  
)

export default component.exports